// ============================================================================
// apps/vpnRenderer.tsx — ПРИЛОЖЕНИЕ «VPN» (рендерер appKind='vpn'):
// ЛЮБОЙ пользователь с доступом к VPN видит «Подключения» (доступные ему
// профили, кнопка «Подключиться», QR/файл настроек); управляющий VPN
// (админ / vpn_manage) дополнительно открывает режим «Управление» прямо здесь.
//
// Доступ: администратор ИЛИ системные роли «VPN-клиент» (vpn_client) /
// «VPN-управление» (vpn_manage). Без ролей приложение СКРЫТО в доке/«Пуске»
// (useVisibleApps) и при прямом открытии показывает ЯВНЫЙ отказ (ниже);
// серверные гейты VpnService дублируют проверку (SSoT — сервер, vpn.go).
// ============================================================================

import { ShieldOff } from 'lucide-react';
import { VpnPage } from '@/pages/VpnPage';
import { registerAppRenderer, type AppManifest, APPSDK_VERSION } from '@/lib/apps/sdk';
import { canUseVpn, useSecurityAccess } from '@/lib/securityRoles';

/** Код системного приложения «VPN» (kind='app' code='vpn'; EnsureSystemVpnApp). */
export const VPN_APP_CODE = 'vpn';

function VpnApp() {
  const access = useSecurityAccess();
  if (!canUseVpn(access)) {
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="max-w-md rounded-lg border bg-card p-5 text-center">
          <ShieldOff className="mx-auto mb-2 h-6 w-6 text-muted-foreground" />
          <div className="text-sm font-medium">VPN недоступен для вашей учётной записи</div>
          <div className="mt-1 text-xs text-muted-foreground">
            Попросите администратора открыть вам доступ к VPN. Управление
            подключениями доступно роли «VPN-управление» и администратору базы.
          </div>
        </div>
      </div>
    );
  }
  return <VpnPage />;
}

/** Манифест приложения «VPN» (AppHost): системное, на весь воркспейс. */
export const VPN_APP_MANIFEST: AppManifest = {
  code: VPN_APP_CODE,
  name: 'vpn',
  synonym: 'VPN',
  appKind: 'vpn',
  area: 'full',
  apiVersion: APPSDK_VERSION,
  permissions: ['events', 'notify', 'nav', 'data:read'],
};

export function registerVpnApp(): void {
  registerAppRenderer({
    appKind: 'vpn',
    code: VPN_APP_CODE,
    title: 'VPN',
    Component: VpnApp,
    manifest: VPN_APP_MANIFEST,
  });
}
